import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { LogoColors } from './LogoColors';
import { InversionColor } from './InversionColor';
import { BackgroundColors } from './BackgroundColors';
import { AdditionalColors } from './AdditionalColors';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';
import { useStaticQuery, graphql } from "gatsby"

export const Colors = ({t, i18n}) => {
    i18n.loadNamespaces('colors');

    const pages = [
        {
            title: 'Logo colors',
            component: LogoColors,
        },
        {
            title: 'Icon color inversion',
            component: InversionColor,
        },
        {
            title: 'Logo background colors',
            component: BackgroundColors,
        },
        {
            title: 'Additional background colors',
            component: AdditionalColors,
        },
    ];

    const data = useStaticQuery(graphql`
    {
        allFile(filter: {relativeDirectory: {eq: "colors"}}) {
            edges {
                node {
                    name
                    publicURL
                    relativePath
                }
            }
        }
    }
    `)

    const getFileUrl = (fileName) => {
        const file = data.allFile.edges.filter(edge => edge.node.name === fileName)[0];
        // console.log(file.node.publicURL)

        return file.node.publicURL;
    }

    return (
        <Page>
        <PageNavigation t={t} onThisPage={pages.map(page => t(`colors>${page.title}`))}/>
            <FlexDiv direction="column">
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={index && '50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        getFileUrl: getFileUrl,
                                        t: (text) => t(`colors>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const ColorsContainer = withTrans(Colors);